import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { StaticQuery, graphql } from 'gatsby';
import CookieConsent from 'react-cookie-consent';
import config from '../../config';

import '../assets/sass/grayscale.scss';
require('typeface-varela')
require('typeface-nunito')

class Layout extends Component {
  render() {
    const { children } = this.props;
    return (
      <StaticQuery
        query={graphql`
          query SiteTitleQuery {
            site {
              siteMetadata {
                title
              }
            }
          }
        `}
        render={data => (
          <>
            <Helmet
              title={data.site.siteMetadata.title}
              meta={[
                { name: 'description', content: config.description },
                { name: 'keywords', content: config.keywords },
              ]}
            >
              <html lang="en" />
            </Helmet>
            <div className={'page-top'}>{children}</div>
            <CookieConsent
              location="bottom"
              buttonText="Accept"
              style={{ background: "#0377ad"}}
              buttonStyle={{ backgroundColor: "white", color: "#0377ad", fontSize: "13px" }}
              flipButtons={true}
              cookieName="etl-cookie-concent">
              We use cookies to ensure that we give you the best experience on our website. If you continue to use this site we will assume that you accept it :)
              <a style={{color:"white", opacity:'0.8', 'marginLeft':'16px'}} rel="noreferrer" href="https://www.chinasystems.com/privacy_policy.html" target="_blank"> Cookies and Privacy Policy </a>  
            </CookieConsent>
          </>
        )}
      />
    );
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
